import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProductionService } from '@app/shared/services/production.service';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { InventoryItem, InventoryService } from '@app/shared/services/inventory.service';

interface Dispatch {
  dispatched: number;
  kgsBal: number;
}
@Component({
  selector: 'app-prod-form',
  templateUrl: './prod-form.component.html',
  styleUrls: ['./prod-form.component.css']
})
export class ProdFormComponent implements OnInit {
  productionForm: FormGroup;
  productionId: string;

  //tabbing
  // tabActive: string = 'printing'; // Default active tab
  tabActive: string | null = null; // Default: No tab active

  savedProductionData: any[] = []; // Array to store saved production data
  savedInkData: any[] = [];

  savedDownTimeData: any[] = []; // Array to store saved downtime data



   // Array to track already selected matRollNo (to remove them from the dropdown)
   usedMatRollNos: Set<string> = new Set();

   // Variable to track whether Save button should be enabled
  isSaveEnabled: boolean = false;
  // Variable to track whether Save Ink button should be enabled
  // isInkSaveEnabled: boolean = false;

   // This function will check if the submit button should be enabled or not
   isSubmitEnabled(): boolean {
    // Check if any of the arrays have data with values greater than zero
    const hasProductionData = this.savedProductionData.some(data => data.prodWeight > 0 || data.prodOutputKg > 0);
    const hasInkData = this.savedInkData.some(data => data.issue > 0 || data.inkReturn > 0);

    // Enable the submit button only if both arrays have data with values greater than zero(or)
    return (hasProductionData || hasInkData);

    // Enable the submit button only if both arrays have data with values greater than zero(both)
  // return (hasProductionData && hasInkData);
  }

  tabCompletion = {
    printing: 0,
    lamination: 0,
    slitting: 0,
    cutting: 0
  };



  //
  showFormForProcess: boolean[] = [];  // Track whether to show the form for each process

  showFields: boolean[] = [];  // Track whether to show additional fields for each process

  inventoryList: InventoryItem[] = [];


  // Mapping for Material Categories to Specifications
  materialSpecificationsMap = {
    'CLEAR BOPP ': ['CLEAR BOPP [950mm X 18Î¼m]', 'CLEAR BOPP [930mm X 18Î¼m]', 'CLEAR BOPP [720mm X 40Î¼m]'],
    'MET BOPP': ['MET BOPP 40mm * 45mm', 'MET BOPP 70mm * 90mm'],
    'ADDITIVES': ['ADDITIVES'],
    'C BOPP': ['C BOPP'],
    'CLEAR CPP': ['CLEAR CPP 5mm * 4mm', 'CLEAR CPP 7mm * 9mm'],
    'PEARLIZED BOPP': ['PEARLIZED BOPP'],
    'PET': ['PET'],
    'PET G': ['PET G'],
  };

  // Specifications based on selected category
  matSpecifications: string[] = [];



  //table
  materialMixEntries: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;


  //extended table(based on process selection)
   // Define flags for each process type
   isAddProduction: boolean = false;
   isInking: boolean = false;


    // Define the intervals array to hold 15-minute time slots
    timeIntervals: string[] = [];
      // Define an array to store 1-hour intervals
  // hourIntervals: string[] = [];

  filteredInventoryList: any[] = [];  // List for filtered inventory items based on matSpecification



  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router:Router,
    private productionService: ProductionService,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,

    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,private activatedRoute: ActivatedRoute,
  ) {

    this.productionService.materialMixEntries$.subscribe(entries => {
      this.materialMixEntries = entries;
    });
     // Try to fetch the saved data from localStorage
     const savedData = localStorage.getItem('materialMixEntries');
     if (savedData) {
       this.materialMixEntries = JSON.parse(savedData);
     }
   }

  ngOnInit(): void {
    // Get the ID from the route parameters
    this.route.paramMap.subscribe(params => {
      this.productionId = params.get('id');
      this.loadProductionData();


      //for edit(update)
      this.activatedRoute.params.subscribe(params => {
        console.log('Route Params:', params);
        const productionId = params['id']; 
        if (productionId) {
          this.productionId = productionId;
          console.log('Extracted productionId:', this.productionId);
          this.updateProduction(this.productionId); // Fetch production details by MongoDB _id
        } else {
          console.error('No production ID found with this');
        }
      });
    });

    this.initializeForm();

    this.generateTimeIntervals();
    // this.generateHourIntervals();



    //new order
    // Fetch data for new order process and material
    this.fetchUnsavedOrderData(this.productionId);
    
  }

  // Generate the time intervals in a 24-hour format
  generateTimeIntervals(): void {
    // const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    const minutes = ['00', '15', '30', '45', '60'];  // 15-minute intervals
    
    // for (let h of hours) {
      for (let m of minutes) {
        // this.timeIntervals.push(`${h}:${m}`);
        this.timeIntervals.push(`${m}`);
      }
    // }
  }

  // Generate the time intervals from 00:00 to 23:00 with 1-hour intervals
  // generateHourIntervals(): void {
  //   const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    
  //   // Add the hour intervals in HH:00 format
  //   for (let h of hours) {
  //     this.hourIntervals.push(`${h}:00`);
  //   }
  // }

  initializeForm(): void {
    this.productionForm = this.fb.group({


      // extrusion: [false],
      addProduction: [false],
      inking: [false],
      // extrusionJobName: ['', Validators.required],
      // extrusionClientName: ['', Validators.required],
      // extrusionOrderKgs: ['', Validators.required],

      //production
      // materialCategory: ['', Validators.required],
      // matSpecifications: ['', Validators.required],
      //for creating dynamic updation based on material category
      materialCategory: new FormControl('CLEAR BOPP '), // Default value
      matSpecifications: new FormControl('CLEAR BOPP '), // Default specification
      
      // matRollNo: ['', Validators.required],
      matRollNo: [''],

      // prodWeight: ['', Validators.required],
      // prodReturn: ['', Validators.required],
      // prodOutputRollNo: ['', Validators.required],
      // prodOutputKg: ['', Validators.required],
      // prodWaste: ['', Validators.required],
      // prodFlag: ['', Validators.required],
      //without validation
      prodWeight: ['', []],
      prodReturn: ['', []],
      prodOutputRollNo: ['', []],
      prodOutputKg: ['', []],
      prodWaste: ['', []],
      prodFlag: ['', []],



      // availTime: ['', Validators.required],
      availTime:['', []],
      //


      //bunch ink field
      // inkType: ['', Validators.required],
      // inkName: ['', Validators.required],
      // inkColor: ['', Validators.required],
      // inkReturn: ['', Validators.required],
      // issue: ['', Validators.required],
      //bunch ink field
      inkType: ['', []],
      inkName: ['', []],
      inkColor: ['', []],
      inkReturn: ['', []],
      issue: ['', []],

      // breakdown: ['', Validators.required],


      orderKgs: [null, Validators.required],
      poNo: [null, Validators.required],
      clientName: [null, Validators.required],
      ticketNo: [null, Validators.required],
    
      // orderPc: [null, Validators.required],
      // orderNo: [null, Validators.required],
      refNo: [null, Validators.required],
      jobName: [null, Validators.required],
      poNumber: [null, Validators.required],

      //shift
      shift:['', Validators.required],
      // machine :[null, Validators.required],
      //for placeholder
      machine: ['', Validators.required],
       operator :['', Validators.required],
      // operatingTime :[null, Validators.required],
      // timeFrom :[null, Validators.required],
      timeFrom : ['00:00', Validators.required], 
      // timeTo :[null, Validators.required],
      timeTo :['00:00', Validators.required],
      operatingTime :['', Validators.required],
      mcSpeed :[null, Validators.required],
      inkGsm :[null, Validators.required],

      //inking inking
      breakdown: [false],
      // downTime: ['', Validators.required],
      //  downTimeTime: ['', Validators.required],
      //  downTimeRemarks: ['', Validators.required],
      downTime: ['', []],  // Make these fields optional
      downTimeTime: ['', []],
      downTimeRemarks: ['', []],

      combinedMaterials: this.fb.array([]) , // FormArray for combinedMaterials



//new order
newOrderFields: this.fb.array([]), // Add this for dynamic process and material fields





  // Lamination related form controls(dummytext)
  laminationMachine: ['', []],
  laminationFilm: ['', []],
  laminationOperator: ['', []],
  // Slitting related form controls
  slittingMachine: ['', []],
  slittingSize: ['', []],
   // Cutting related form controls
   cuttingMachine: ['', []],
   cuttingParameters: ['', []],

    });

       // Listen for changes to the matSpecifications and matRollNo fields
       this.trackFields();
        // Listen for changes to the inkName, inkColor, and inkType fields
    // this.trackInkFields();
     // Watch for changes and update the progress
     this.productionForm.valueChanges.subscribe(() => {
      this.updateTabCompletion();
    });




     //for matrollno(based on matrollno it fill fetch weight(prodWeight))
     this.getInventoryList();

      //(before removal of selection from dropdown)
     //(prodweight here)
     // Listen for matRollNo changes to auto-fill related fields
     this.productionForm.get('matRollNo')?.valueChanges.subscribe((selectedRollNo) => {
       const selectedRoll = this.inventoryList.find((roll) => roll.rollNo === selectedRollNo);
       if (selectedRoll) {
         // Auto-fill other fields based on selected inventory roll
         this.productionForm.get('prodWeight')?.setValue(selectedRoll.qty);  // Example: Set quantity
         // Example: Set material description
        //  this.productionForm.get('prodFlag')?.setValue(selectedRoll.materialDescription); 
       }
       else {
        // If no matching roll is found, set prodWeight to 0
        this.productionForm.get('prodWeight')?.setValue(0);
      }
     });


          //(after removal of selection from dropdown)
     // Listen for changes in matRollNo to capture the selected value
    //  this.productionForm.get('matRollNo')?.valueChanges.subscribe((selectedRollNo) => {
    //   // If a matRollNo is selected and it hasn't been used yet
    //   if (selectedRollNo && !this.usedMatRollNos.has(selectedRollNo)) {
    //     // Track the roll number as used
    //     this.usedMatRollNos.add(selectedRollNo);

    //     // Find the selected roll in the inventory list
    //     const selectedRoll = this.inventoryList.find((roll) => roll.rollNo === selectedRollNo);

    //     if (selectedRoll) {
    //       // Auto-fill other fields based on selected inventory roll
    //       this.productionForm.get('prodWeight')?.setValue(selectedRoll.qty);  // Example: Set quantity
    //       // Optionally, you can also set other fields like material description
    //       // this.productionForm.get('prodFlag')?.setValue(selectedRoll.materialDescription); 
    //     } else {
    //       // If no matching roll is found, set prodWeight to 0
    //       this.productionForm.get('prodWeight')?.setValue(0);
    //     }
    //   }
    // });
    // 
    // 
    // 



    // Listen for matSpecifications changes and fetch matRollNo based on subcategory
    // this.productionForm.get('matSpecifications')?.valueChanges.subscribe((selectedSpecification) => {
    //   this.fetchMatRollNo(selectedSpecification);
    // });

     // Listen for changes in matSpecifications to filter matRollNo based on matSpecification
     this.productionForm.get('matSpecifications')?.valueChanges.subscribe((selectedSpecification) => {
      this.filterMatRollNoBySpecification(selectedSpecification);
    });

    // Set initial specifications based on the default material category
    this.setSpecifications('CLEAR BOPP ');

    // Listen for materialCategory change and update specifications
    this.productionForm.get('materialCategory')?.valueChanges.subscribe(value => {
      this.setSpecifications(value);
    });






     // Listen for changes on timeFrom and timeTo fields
     this.productionForm.get('timeFrom')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });

    this.productionForm.get('timeTo')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });




    this.productionForm.get('downTimeTime')?.valueChanges.subscribe(() => {
      this.calculateAvailableTime();
    });



       //for creating dynamic updation based on material category
     // Set initial specifications based on the default material category
     this.setSpecifications('CLEAR BOPP ');
    
     // Listen for materialCategory change and update specifications
     this.productionForm.get('materialCategory')?.valueChanges.subscribe(value => {
       this.setSpecifications(value);
     });
  }


  //for creating dynamic updation based on material category
  // Method to update matSpecifications based on materialCategory
  setSpecifications(materialCategory: string): void {
    if (this.materialSpecificationsMap[materialCategory]) {
      this.matSpecifications = this.materialSpecificationsMap[materialCategory];
      // Reset matSpecifications to the first option
      this.productionForm.patchValue({
        matSpecifications: this.matSpecifications[0]
      });
    }
  }

  // Method to filter matRollNo based on the selected matSpecifications
  //(without removing from dropdown)
  // filterMatRollNoBySpecification(selectedSpecification: string): void {
  //   // Filter inventoryList to get items matching the selected matSpecification
  //   this.filteredInventoryList = this.inventoryList.filter(item => item.subcategory === selectedSpecification);
    
  //   // Optionally, reset the matRollNo if no matching item is found
  //   if (this.filteredInventoryList.length === 0) {
  //     //without console(working)
  //     this.productionForm.get('matRollNo')?.setValue(null);

  //     // If no matching items, set matRollNo to "NA" and prodWeight to 0
  //     // this.productionForm.get('matRollNo')?.setValue('NA');
  //     // this.productionForm.get('prodWeight')?.setValue(0);
  //     // console.log("No matching Mat Roll No found, setting matRollNo to 'NA' and prodWeight to 0");
  //   }
  // }

  //(after removing)
  // Modify the method that listens for changes in matSpecifications
  filterMatRollNoBySpecification(selectedSpecification: string): void {
    // Filter inventoryList to get items matching the selected matSpecification and not previously used
    this.filteredInventoryList = this.inventoryList.filter(item =>
      item.subcategory === selectedSpecification && !this.usedMatRollNos.has(item.rollNo)
    );

    // Reset matRollNo if no matching item is found
    if (this.filteredInventoryList.length === 0) {
      this.productionForm.get('matRollNo')?.setValue(null);
    }
  }

  // Listen for changes in matRollNo to track used matRollNos
  trackUsedMatRollNo(): void {
    this.productionForm.get('matRollNo')?.valueChanges.subscribe((selectedRollNo) => {
      if (selectedRollNo && !this.usedMatRollNos.has(selectedRollNo)) {
        this.usedMatRollNos.add(selectedRollNo); // Add to the set of used roll numbers
      }
    });
  }




 // Fetch matRollNo based on matSpecifications
//  fetchMatRollNo(selectedSpecification: string): void {
//   // Check if the selected matSpecification matches any inventory item's subcategory
//   const matchingInventoryItem = this.inventoryList.find((item) => item.subcategory === selectedSpecification);

//   if (matchingInventoryItem) {
//     // If a match is found, set the matRollNo to the matching inventory item's rollNo
//     this.productionForm.get('matRollNo')?.setValue(matchingInventoryItem.rollNo);
//     console.log(`Matching Inventory Item Found:`, matchingInventoryItem.rollNo); // Log the rollNo
//   } else {
//     // If no match is found, set matRollNo to "NA"
//     this.productionForm.get('matRollNo')?.setValue("NA");
//     console.log("No matching Inventory Item found, setting matRollNo to 'NA'"); // Log "NA"
//   }
// }






  //calculating time difference
  // Method to calculate the difference between timeFrom and timeTo
  // calculateTimeDifference(): void {
  //   const timeFrom = this.productionForm.get('timeFrom')?.value;
  //   const timeTo = this.productionForm.get('timeTo')?.value;

  //   // Ensure both timeFrom and timeTo are valid before calculating
  //   if (timeFrom && timeTo) {
  //     const timeFromDate = this.convertTimeToDate(timeFrom);
  //     const timeToDate = this.convertTimeToDate(timeTo);

  //     // Calculate the time difference in milliseconds
  //     const diffInMilliseconds = timeToDate.getTime() - timeFromDate.getTime();

  //     // Convert the difference into hours and minutes
  //     const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60)); // Hours
  //     const diffInMinutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)); // Minutes

  //     // Format the time difference as HH:mm
  //     const formattedTime = this.formatTime(diffInHours, diffInMinutes);

  //     // Update the operatingTime field in the form with HH:mm format
  //     this.productionForm.patchValue({
  //       operatingTime: formattedTime
  //     });

  //     // Print the difference in the console in HH:mm format
  //     console.log('Operating Time Difference (HH:mm):', formattedTime);
  //   }
  // }
  // Method to calculate the difference between timeFrom and timeTo in minutes(in minutes format)
calculateTimeDifference(): void {
  const timeFrom = this.productionForm.get('timeFrom')?.value;
  const timeTo = this.productionForm.get('timeTo')?.value;

  // Ensure both timeFrom and timeTo are valid before calculating
  if (timeFrom && timeTo) {
    const timeFromDate = this.convertTimeToDate(timeFrom);
    const timeToDate = this.convertTimeToDate(timeTo);

    // Calculate the time difference in milliseconds
    const diffInMilliseconds = timeToDate.getTime() - timeFromDate.getTime();

    // Convert the difference into minutes
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60)); // Minutes

    // Update the operatingTime field to display the time difference in minutes format
    this.productionForm.patchValue({
      operatingTime: `${diffInMinutes} minutes`  // Displaying it as "XXX minutes"
    });

    // Print the difference in the console in minutes format
    console.log('Operating Time Difference:', `${diffInMinutes} minutes`);
  }
}

//available time
calculateAvailableTime(): void {
  // Get the operating time and breakdown time from the form
  const operatingTime = this.productionForm.get('operatingTime')?.value;  // Operating time in minutes
  const downTime = this.productionForm.get('downTimeTime')?.value || '00';  // Breakdown time, default to '00' if not selected
  
  // Extract the numeric value of operatingTime (e.g., '120 minutes' to 120)
  const operatingTimeInMinutes = this.extractMinutesFromString(operatingTime);

  // Convert breakdown time to minutes (e.g., '15' to 15 minutes)
  const breakdownTimeInMinutes = this.parseTimeToMinutes(downTime);

  // Calculate available time (operating time - breakdown time)
  const availableTime = operatingTimeInMinutes - breakdownTimeInMinutes;

  // Update the availTime field in the form with the calculated available time
  this.productionForm.patchValue({
    availTime: `${availableTime} minutes`  // Display as "XXX minutes"
  });

  // Print the result in the console
  console.log('Available Time:', `${availableTime} minutes`);
}

// Helper function to extract the number of minutes from the "XXX minutes" string
extractMinutesFromString(time: string): number {
  const match = time.match(/(\d+)/);  // Extracts the numeric part from the string
  return match ? parseInt(match[0], 10) : 0;  // Returns the number of minutes, defaulting to 0
}

// Helper function to convert time (e.g., '00', '15', '30') to minutes
parseTimeToMinutes(time: string): number {
  const timeMapping = {
    '00': 0,
    '15': 15,
    '30': 30,
    '45': 45,
    '60': 60
  };
  return timeMapping[time] || 0;
}




  // Fetch the list of inventory rolls
  getInventoryList(): void {
    this.inventoryService.getAllInventry().subscribe((response) => {
      this.inventoryList = response;  // Populate the list of inventory items
    });

     // Initialize filtered list based on default matSpecification
     this.filterMatRollNoBySpecification(this.matSpecifications[0]);
  }

   // Auto-fill other fields based on selected matRollNo
   autoFillFieldsForMatRollNo(selectedRollNo: string): void {
    const selectedRoll = this.inventoryList.find((roll) => roll.rollNo === selectedRollNo);
    if (selectedRoll) {
      // Auto-fill prodWeight based on selected roll
      this.productionForm.get('prodWeight')?.setValue(selectedRoll.qty);
    } else {
      // If no matching roll is found, set prodWeight to 0
      this.productionForm.get('prodWeight')?.setValue(0);
    }
  }

  // Helper function to convert time string to Date object
  convertTimeToDate(time: string): Date {
    const [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    return date;
  }

  // Helper function to format hours and minutes as HH:mm
  formatTime(hours: number, minutes: number): string {
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${formattedHours}:${formattedMinutes}`;
  }





  // Method to switch between tabs
// onTabChange(tabName: string) {
//   this.tabActive = tabName;
// }
// Method to switch between tabs
onTabChange(tabName: string) {
  this.tabActive = this.tabActive === tabName ? null : tabName; // Toggle tab state
}


// Method to save production data

saveProductionData() {
  const formValues = this.productionForm.value;

  // Capture relevant data
  const productionData = {
    // matSpecifications: formValues.matSpecifications,
    // matRollNo: formValues.matRollNo,
    // prodFlag: formValues.prodFlag,
    // prodWeight: formValues.prodWeight,
    matSpecifications: formValues.matSpecifications,
    matRollNo: formValues.matRollNo,
    prodFlag: formValues.prodFlag,
    prodWeight: formValues.prodWeight,
    prodReturn: formValues.prodReturn,
    prodOutputRollNo: formValues.prodOutputRollNo,
    prodOutputKg: formValues.prodOutputKg,
    prodWaste: formValues.prodWaste,
  };


  // Log the productionData to console before saving it
  console.log('Saving production data:', productionData);


  // Push to saved data array
  this.savedProductionData.push(productionData);

  // Optionally, reset specific fields after saving
  // this.productionForm.patchValue({
  //   matSpecifications: '',
  //   matRollNo: '',
  //   prodFlag: '',
  //   prodWeight: '',
  // });
    // Optionally, reset the form or just the specific fields for the production section
    this.productionForm.get('matSpecifications').reset();
    this.productionForm.get('matRollNo').reset();
    this.productionForm.get('prodFlag').reset();
    this.productionForm.get('prodWeight').reset();
    this.productionForm.get('prodReturn').reset();
    this.productionForm.get('prodOutputRollNo').reset();
    this.productionForm.get('prodOutputKg').reset();
    this.productionForm.get('prodWaste').reset();
}

deleteProductionData(index: number) {
  // Remove the data from the array at the given index
  this.savedProductionData.splice(index, 1);
  
  // Optionally, log the deletion for debugging purposes
  console.log('Deleted production data at index:', index);
}

// savedInkData: any[] = [];

//here adding detail to existing whole array
// saveInkData() {
//     // Capture the ink data from the form
//     const inkData = this.productionForm.value;

//     // Push the ink data to the savedInkData array
//     this.savedInkData.push({
//         inkName: inkData.inkName,
//         inkColor: inkData.inkColor,
//         inkType: inkData.inkType,
//         issue: inkData.issue,
//         inkReturn: inkData.inkReturn
//     });

//      // Log the inkData to console before saving it
//   console.log('Saving ink data:', inkData);

//     // Optionally, reset the form or just the inking-specific fields
//     // this.productionForm.reset();
//     // Or reset only the inking section:
//     this.productionForm.get('inkName').reset();
//     this.productionForm.get('inkColor').reset();
//     this.productionForm.get('inkType').reset();
//     this.productionForm.get('issue').reset();
//     this.productionForm.get('inkReturn').reset();
// }
saveInkData() {
  // Capture the ink data from the form
  const inkData = this.productionForm.value;

  // Define the ink data structure for saving
  const inkDetails = {
    inkName: inkData.inkName,
    inkColor: inkData.inkColor,
    inkType: inkData.inkType,
    issue: inkData.issue,
    inkReturn: inkData.inkReturn
  };

  // Log the inkDetails to console before saving it
  console.log('Saving ink data:', inkDetails);

  // Push to saved ink data array
  this.savedInkData.push(inkDetails);

  // Optionally, reset specific fields after saving
  this.productionForm.get('inkName').reset();
  this.productionForm.get('inkColor').reset();
  this.productionForm.get('inkType').reset();
  this.productionForm.get('issue').reset();
  this.productionForm.get('inkReturn').reset();
}

deleteInkData(index: number) {
  // Remove the ink data from the array at the given index
  this.savedInkData.splice(index, 1);
  
  // Optionally, log the deletion for debugging purposes
  console.log('Deleted ink data at index:', index);
}




// ink save button
// trackInkFields(): void {
//   // Listen for changes in inkName, inkColor, and inkType to enable/disable Save Ink button
//   this.productionForm.get('inkName')?.valueChanges.subscribe((value) => {
//     console.log('inkName changed to:', value);  // Log the value of inkName when it changes
//     this.checkInkFormCompletion();
//   });

//   this.productionForm.get('inkColor')?.valueChanges.subscribe(() => {
//     this.checkInkFormCompletion();
//   });

//   // this.productionForm.get('inkType')?.valueChanges.subscribe(() => {
//   //   this.checkInkFormCompletion();
//   // });
// }
// checkInkFormCompletion(): void {
//   const inkNameFilled = this.productionForm.get('inkName')?.value;
//   const inkColorFilled = this.productionForm.get('inkColor')?.value;
//   // const inkTypeFilled = this.productionForm.get('inkType')?.value;

//   // Enable the Save Ink button only if all ink fields are filled
//   // this.isInkSaveEnabled = !!inkNameFilled && !!inkColorFilled && !!inkTypeFilled;
//   this.isInkSaveEnabled = !!inkNameFilled && !!inkColorFilled;
// }

// production save button
trackFields(): void {
  // Listen for changes in matSpecifications and matRollNo to enable/disable Save button
  this.productionForm.get('matSpecifications')?.valueChanges.subscribe((value) => {
    console.log('matSpecifications changed to:', value);
    this.checkFormCompletion();
  });

  this.productionForm.get('matRollNo')?.valueChanges.subscribe(() => {
    this.checkFormCompletion();
  });
}
checkFormCompletion(): void {
  const matSpecificationsFilled = this.productionForm.get('matSpecifications')?.value;
  const matRollNoFilled = this.productionForm.get('matRollNo')?.value;

  // Enable the Save button only if both fields are filled
  this.isSaveEnabled = !!matSpecificationsFilled && !!matRollNoFilled;
}

updateTabCompletion() {
  // Update completion status for each tab
  // this.tabCompletion.printing = this.checkTabCompletion(['matRollNo', 'prodWeight', 'prodOutputRollNo', 'prodOutputKg', 'prodWaste', 'prodFlag']);
  this.tabCompletion.printing = this.checkTabCompletion(['addProduction', 'inking']  // Checkboxes
  );
  // const printingFields = [ 
  //   'addProduction', 'inking', 'matRollNo', 'prodWeight', 'inkName', 'inkType'
  // ];
  // this.tabCompletion.printing = this.checkTabCompletion(printingFields);
  this.tabCompletion.lamination = this.checkTabCompletion(['laminationMachine', 'laminationFilm', 'laminationOperator']);
  this.tabCompletion.slitting = this.checkTabCompletion(['slittingMachine', 'slittingSize']);
  this.tabCompletion.cutting = this.checkTabCompletion(['cuttingMachine', 'cuttingParameters']);
}

// checkTabCompletion(fields: string[]): number {
//   const completedFields = fields.filter(field => this.productionForm.get(field)?.valid);
//   return Math.round((completedFields.length / fields.length) * 100);
// }

 // Helper function to check if required fields are filled(check for required field same as above)
//  checkTabCompletion(requiredFields: string[]): boolean {
//   return requiredFields.every(field => !!this.productionForm.get(field).value);
// }
checkTabCompletion(fields: string[]): number {
  const completedFields = fields.filter(field => {
    const control = this.productionForm.get(field);
    return control?.value && control.valid;  // Ensure the field has a value and is valid
  });
  return Math.round((completedFields.length / fields.length) * 100);
}



captureDownTime() {
  const formValues = this.productionForm.value;

  // Capture relevant downtime data
  const downtimeData = {
    downTime: formValues.downTime,
    downTimeTime: formValues.downTimeTime,
    downTimeRemarks: formValues.downTimeRemarks,
  };

  // Log the downtime data to console before saving it
  console.log('Capturing downtime data:', downtimeData);

  // Push to saved downtime data array
  this.savedDownTimeData.push(downtimeData);

  // Optionally, reset specific fields after saving
  this.productionForm.get('downTime').reset();
  this.productionForm.get('downTimeTime').reset();
  this.productionForm.get('downTimeRemarks').reset();
}




  onProcessChange(process: string) {
    // Update form controls based on selected processes
    // if (process === 'extrusion') {
    //   if (this.productionForm.get('extrusion').value) {
    //     this.productionForm.addControl('extrusionJobName', this.fb.control(''));
    //     this.productionForm.addControl('extrusionClientName', this.fb.control(''));
    //     this.productionForm.addControl('extrusionOrderKgs', this.fb.control(''));
    //   } else {
    //     this.productionForm.removeControl('extrusionJobName');
    //     this.productionForm.removeControl('extrusionClientName');
    //     this.productionForm.removeControl('extrusionOrderKgs');
    //   }
    // }

   //extended table(based on process selection)
   //to select only one process
  //  this.isAddProduction = process === 'addProduction';
  //  this.isInking = process === 'inking';

  // Update flags based on selected processes
  if (process === 'addProduction') {
    this.isAddProduction = !this.isAddProduction;
  } else if (process === 'inking') {
    this.isInking = !this.isInking;
  }

  // Dynamically add or remove form controls based on selected processes
  if (this.isAddProduction) {
    this.addAddProductionFields();
  } else {
    this.removeAddProductionFields();
  }

  if (this.isInking) {
    this.addInkingFields();
  } else {
    this.removeInkingFields();
  }



 


    if (process === 'addProduction') {
      if (this.productionForm.get('addProduction').value) {
        this.productionForm.addControl('materialCategory', this.fb.control(''));
        this.productionForm.addControl('matSpecifications', this.fb.control(''));
        this.productionForm.addControl('matRollNo', this.fb.control(''));
        this.productionForm.addControl('prodWeight', this.fb.control(''));
        this.productionForm.addControl('prodReturn', this.fb.control(''));
        this.productionForm.addControl('prodOutputRollNo', this.fb.control(''));
        this.productionForm.addControl('prodOutputKg', this.fb.control(''));
        this.productionForm.addControl('prodWaste', this.fb.control(''));
        this.productionForm.addControl('prodFlag', this.fb.control(''));

        this.productionForm.addControl('availTime', this.fb.control(''));
      } else {
        this.productionForm.removeControl('materialCategory');
        this.productionForm.removeControl('matSpecifications');
        this.productionForm.removeControl('matRollNo');
        this.productionForm.removeControl('prodWeight');
        this.productionForm.removeControl('prodReturn');
        this.productionForm.removeControl('prodOutputRollNo');
        this.productionForm.removeControl('prodOutputKg');
        this.productionForm.removeControl('prodWaste');
        this.productionForm.removeControl('prodFlag');

        this.productionForm.removeControl('availTime');
      }
    }
    if (process === 'inking') {
      if (this.productionForm.get('inking').value) {
        this.productionForm.addControl('inkType', this.fb.control(''));
        this.productionForm.addControl('inkName', this.fb.control(''));
        this.productionForm.addControl('inkColor', this.fb.control(''));
        this.productionForm.addControl('inkReturn', this.fb.control(''));
        this.productionForm.addControl('issue', this.fb.control(''));
        // this.productionForm.addControl('breakdown', this.fb.control(''));
      } else {
        this.productionForm.removeControl('inkType');
        this.productionForm.removeControl('inkName');
        this.productionForm.removeControl('inkColor');
        this.productionForm.removeControl('inkReturn');
        this.productionForm.removeControl('issue');
        // this.productionForm.removeControl('breakdown');
      }
    }
  }

  addAddProductionFields() {
  
    this.productionForm.addControl('matSpecifications', this.fb.control(''));
    this.productionForm.addControl('matRollNo', this.fb.control(''));
    this.productionForm.addControl('prodWeight', this.fb.control(''));

    this.productionForm.addControl('availTime', this.fb.control(''));
   
  }
  
  removeAddProductionFields() {
   
    this.productionForm.removeControl('matSpecifications');
    this.productionForm.removeControl('matRollNo');
    this.productionForm.removeControl('prodWeight');

    this.productionForm.removeControl('availTime');
    
  }
  
  addInkingFields() {
    this.productionForm.addControl('inkType', this.fb.control(''));
    this.productionForm.addControl('inkName', this.fb.control(''));
    this.productionForm.addControl('inkColor', this.fb.control(''));
   
  }
  
  removeInkingFields() {
    this.productionForm.removeControl('inkType');
    this.productionForm.removeControl('inkName');
    this.productionForm.removeControl('inkColor');
   
  }


  

  //Breakdown
  onProcessChangeBreakdown(process: string) {
    // Update form controls based on selected processes
    if (process === 'breakdown') {
      if (this.productionForm.get('breakdown').value) {
        this.productionForm.addControl('downTime', this.fb.control(''));
        this.productionForm.addControl('downTimeTime', this.fb.control(''));
        this.productionForm.addControl('downTimeRemarks', this.fb.control(''));
      } else {
        this.productionForm.removeControl('downTime');
        this.productionForm.removeControl('downTimeTime');
        this.productionForm.removeControl('downTimeRemarks');
      }
    }
   
    
  }



  //  // Fetch unsaved order data
  //  fetchUnsavedOrderData(): void {
  //   this.orderDataService.getAllUnsavedOrders().subscribe((orderData: any) => {
  //     this.populateNewOrderFields(orderData);
  //   });
  // }

  // // Populate new order fields dynamically
  // populateNewOrderFields(orderData: any): void {
  //   const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
  //   newOrderFormArray.clear();  // Clear any existing fields

  //   // Check for each process and material, and add form controls for each
  //   for (let i = 1; i <= 6; i++) {
  //     const process = orderData[`Process${i}`];
  //     const material = orderData[`material${i}`];

  //     if (process && material) {
  //       newOrderFormArray.push(this.fb.group({
  //         process: [process],
  //         material: [material],
  //         matSize: [orderData[`matSize${i}`]],
  //         thickness: [orderData[`thickness${i}`]],
  //         matRequired: [orderData[`matReq${i}`]],
  //       }));
  //     }
  //   }
  // }
  // Fetch unsaved order data
fetchUnsavedOrderData(productionId:any): void {
  console.log('Fetching unsaved order data...');
  
  this.orderDataService.getUnsavedOrderById(productionId).subscribe((orderData: any) => {
    console.log('Fetched unsaved order data:', orderData);
    
    this.populateNewOrderFields(orderData);  // Pass orderData, not productionId
  }, error => {
    console.error('Error fetching unsaved order data:', error);
  });
}

// Populate new order fields dynamically(older working)
// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:',orderData);

//   // Make sure orderData is an array of objects (you can adjust this based on your data shape)
//   if (Array.isArray(orderData)) {
//     const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//     newOrderFormArray.clear(); // Clear the existing fields
  
//     for (let j = 1; j < orderData.length; j++) {
//       // Loop through processes (Process1 to Process5)
//       for (let i = 1; i < 6; i++) {
//         const process = orderData[j][`Process${i}`];
//         console.log(`Order ${j}, Process ${i}:`, process);
        
//         // Only add if process is valid
//         if (process && process !== 'NaN') {
//           newOrderFormArray.push(this.fb.group({
//             process: [process],
//             material: [orderData[j][`Material${i}`] || ''],
//           }));
//         }
//       }
//     }
//   }
  
// }



populateNewOrderFields(orderData: any): void {
  console.log('Populating new order fields with data:', orderData);

  // Check if orderData is an object
  if (orderData && typeof orderData === 'object') {
    const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
    newOrderFormArray.clear(); // Clear any existing form fields

    // Loop through each Process field dynamically (e.g., Process1, Process2, ..., ProcessN)
    for (let i = 1; i <= 6; i++) { // Adjust this loop based on the max number of processes
      const process = orderData[`Process${i}`]; // Correct string interpolation for process
      const material = orderData[`material${i}`]; // Correct string interpolation for material
      const matReq = orderData[`matReq${i}`]; // Correct string interpolation for matReq

      console.log(`Process ${i}:`, process);
      console.log(`Material ${i}:`, material);
      console.log(`MatReq ${i}:`, matReq);

      // Only add a form control if the process exists and is not 'NaN'
      if (process && process !== 'NaN') {
        newOrderFormArray.push(this.fb.group({
          process: [process], // Add process to form
          material: [material || ''], // Add material to form (default to empty string if not available)
          matReq: [matReq || '0'], // Add matReq to form (default to '0' if not available)
        }));
      }
    }

    // Trigger change detection manually after updating the form array
    this.cdr.detectChanges();
  } else {
    console.error('Order data is not in the expected format.');
  }
}

//(with material and process only)
// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:', orderData);

//   // Check if orderData is an object
//   if (orderData && typeof orderData === 'object') {
//     const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//     newOrderFormArray.clear(); // Clear any existing form fields

//     // Loop through each Process field dynamically (e.g., Process1, Process2, ..., ProcessN)
//     for (let i = 1; i <= 6; i++) { // Adjust this loop based on the max number of processes
//       const process = orderData[`Process${i}`]; // Correct string interpolation for process
//       const material = orderData[`material${i}`]; // Correct string interpolation for material

//       console.log(`Process ${i}:`, process);
//       console.log(`Material ${i}:`, material);

//       // Only add a form control if the process exists and is not 'NaN'
//       if (process && process !== 'NaN') {
//         newOrderFormArray.push(this.fb.group({
//           process: [process], // Add process to form
//           material: [material || ''], // Add material to form (default to empty string if not available)
//         }));
//       }
//     }

//     // Trigger change detection manually after updating the form array
//     this.cdr.detectChanges();
//   } else {
//     console.error('Order data is not in the expected format.');
//   }
// }



// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:', orderData);

//   // Check if orderData is an object (not an array of objects as previously assumed)
//   if (orderData && typeof orderData === 'object') {
//     const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//     newOrderFormArray.clear(); // Clear any existing form fields

//     // Loop through each Process field dynamically (e.g., Process1, Process2, ..., ProcessN)
//     for (let i = 1; i <= 6; i++) { // Loop over a fixed range (up to Process6), adjust if necessary
//       const process = orderData[`Process${i}`]; // Get the ProcessX field from orderData
//       const material = orderData[`Material${i}`]; // Get the MaterialX field from orderData
//       // const matReq = orderData[`matReq${i}`]; // Get the matReqX field from orderData

//       console.log(`Process ${i}:`, process);
      
//       // Only add a form control if the process exists and is not 'NaN'
//       if (process && process !== 'NaN') {
//         newOrderFormArray.push(this.fb.group({
//           process: [process],
//           material: [material || ''],
//           // matReq: [matReq || ''], // Add material requirement as well
//         }));
//       }
//     }

//     // Trigger change detection manually after updating the form array
//     this.cdr.detectChanges();
//   } else {
//     console.error('Order data is not in the expected format.');
//   }
// }

 // Handle checkbox change (show or hide the form for the clicked process)
 onProcessCheckboxChange(index: number): void {
  this.showFormForProcess[index] = !this.showFormForProcess[index];
}


// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:', orderData);

//   // Ensure the data is an array
//   if (Array.isArray(orderData)) {
//     const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//     newOrderFormArray.clear();  // Clear existing data in the FormArray before populating it

//     // Loop through the orderData and create FormGroups for each valid process
//     for (let j = 1; j < orderData.length; j++) {
//       for (let i = 1; i < 6; i++) {
//         const process = orderData[j][`Process${i}`];
//         const material = orderData[j][`Material${i}`] || '';  // Default to empty if material is undefined

//         // Only add to the form if the process is valid (not undefined, null, or 'NaN')
//         if (process && process !== 'NaN' && process !== undefined && process !== null) {
//           console.log(`Adding process ${process} and material ${material} to form`);
//           newOrderFormArray.push(this.fb.group({
//             process: [process],
//             material: [material],
//           }));
//         }
//       }
//     }
//   }
// }


// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:', orderData);
//   console.log('Populating process data:', orderData[0].Process1);
//   console.log('Populating process data:', orderData[1].Process2);
//   console.log('Populating process data:', orderData[2].Process3);
//   console.log('Populating process data:', orderData[3].Process4);
//   console.log('Populating process data:', orderData[4].Process5);
//   console.log('Populating process data:', orderData[5].Process6);

//   // const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//   // newOrderFormArray.clear();  // Clear any existing fields

//   // Check for each process and material, and add form controls for each
//   for (let i = 0; i <= orderData[i].Process[i=1]; i++) {
//     const process = orderData[`Process${i}`];
//     const material = orderData[`material${i}`];

//     console.log(`Process ${i}:`, process);
//     console.log(`Material ${i}:`, material);

//     // If both process and material exist, push to form array
//     if (process && material) {
//       // newOrderFormArray.push(this.fb.group({
//         // process: [process],
//         // material: [material],
//         // matSize: [orderData[`matSize${i}`]],
//         // thickness: [orderData[`thickness${i}`]],
//         // matRequired: [orderData[`matReq${i}`]],
//       // }));

//       console.log(`Added form group for process ${i}`);
//     } else {
//       console.warn(`Missing process or material for ${i}`);
//     }
//   }

//   console.log('New order fields populated successfully!');
// }
// Populate new order fields dynamically(for one process only)
// populateNewOrderFields(orderData: any): void {
//   console.log('Populating new order fields with data:', orderData);
  
//   const newOrderFormArray = this.productionForm.get('newOrderFields') as FormArray;
//   newOrderFormArray.clear();  // Clear any existing fields

//   // Fetch only Process1 and Material1
//   const Process1 = orderData.Process1;
//   const Material1 = orderData.material1;

//   console.log('Process1:', Process1);
//   console.log('Material1:', Material1);

//   // If both Process1 and material1 exist, add the form group
//   if (Process1 && Material1) {
//     newOrderFormArray.push(this.fb.group({
//       process: [Process1],
//       material: [Material1],
//       // matSize: [orderData.matSize1],
//       // thickness: [orderData.thickness1],
//       // matRequired: [orderData.matReq1],
//     }));

//     console.log('Added form group for Process1 and Material1');
//   } else {
//     console.warn('Missing process or material for Process1/Material1');
//   }

//   console.log('New order fields populated successfully!');
// }





  // Getter for the FormArray
  get newOrderFields() {
    return (this.productionForm.get('newOrderFields') as FormArray);
  }


  loadProductionData(): void {
    forkJoin({
      repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
      unsavedOrders: this.orderDataService.getAllUnsavedOrders()
    }).subscribe({
      next: (data) => {
        const repeatOrders = Array.isArray(data.repeatOrders) ? data.repeatOrders : [];
        const unsavedOrders = Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [];
        let productionData = repeatOrders.find(order => order._id === this.productionId) ||
                           unsavedOrders.find(order => order._id === this.productionId);
  
        if (productionData) {
          console.log('+', productionData);
          this.populateForm(productionData);
          // Check if the order is completed
          if (productionData.status === 'Closed') {
            alert('This order has already been completed!');
            this.productionForm.disable(); // Disable the form if completed
          }
        } else {
          console.error('No production found with the given ID');
        }
      },
      error: (err) => {
        console.error('Error fetching production data', err);
      }
    });
  }

  // populateForm(productionData: any): void {
  //   this.productionForm.patchValue({
  //     orderKgs: parseFloat(productionData.orderKgs).toFixed(2),
  //     clientName: productionData.clientName,
  //     poNo: productionData.poNo,
  //     ticketNo: productionData.ticketno,
  //     // orderPc: productionData.orderPcs || 0,
  //     // orderNo: productionData.orderId || productionData.jssId,
  //     refNo: productionData.refNo,
  //     jobName: productionData.jobName,
  //     poNumber: productionData.poNo
  //   });
  populateForm(productionData: any): void {
    this.productionForm.patchValue({
      orderKgs: parseFloat(productionData.orderKgs).toFixed(2),
      clientName: productionData.clientName,
      poNo: productionData.poNo,
      ticketNo: productionData.ticketno,
      refNo: productionData.refNo,
      jobName: productionData.jobName,
      poNumber: productionData.poNo,

     
    });
    console.log('Order Kgs:', this.productionForm.get('orderKgs').value);
    console.log('Ticket No:', this.productionForm.get('ticketNo').value);

    // Populate the FormArray for combinedMaterials
    this.setCombinedMaterials(productionData.combinedMaterials);
  }

  // Set combinedMaterials in the form array
  // setCombinedMaterials(combinedMaterials: any[]): void {
  //   const combinedMaterialsFormArray = this.productionForm.get('combinedMaterials') as FormArray;
  //   combinedMaterialsFormArray.clear();  // Clear any existing items

  //   // Loop through the combinedMaterials and add them to the FormArray
  //   combinedMaterials.forEach(material => {
  //     combinedMaterialsFormArray.push(this.fb.group({
  //       process: [material.process],
  //       material: [material.material],
  //       // density: [material.density],
  //       // thickness: [material.thickness],
  //       // gsm: [material.gsm],
  //       // netRm: [material.netRm],
  //       // waste: [material.waste],
  //       // width: [material.width],
  //       // matRequired: [material.matRequired]
  //     }));
  //   });
  
  
  //   this.cdr.detectChanges();
  // }

  setCombinedMaterials(combinedMaterials: any[]): void {
    const combinedMaterialsFormArray = this.productionForm.get('combinedMaterials') as FormArray;
    combinedMaterials.forEach(material => {
      const group = this.fb.group({
        process: [material.process],
        material: [material.material],

        matRequired: [material.matRequired],  // Add matRequired field
        // Add any other fields you want to include for each material
        dummyField1: [''],  // Placeholder fields for when they are toggled
        dummyField2: [''],
        dummyField3: ['']
      });
      combinedMaterialsFormArray.push(group);
    });

    // Initialize showFields array with false (for each process)
    this.showFields = new Array(combinedMaterials.length).fill(false);

     // Manually trigger change detection
  this.cdr.detectChanges();
  }


  // Add a property to control the visibility of the printing-specific fields
// showPrintingFields = false;


  // Toggle visibility of additional fields based on checkbox
  toggleFields(index: number): void {
    this.showFields[index] = !this.showFields[index];

     // Log the selected process value to the console
  const processValue = this.productionForm.get('combinedMaterials').value[index].process;
  console.log(`Process for index ${index}: ${processValue}`);

  // Check if the process is "PRINTING" to show additional fields
  // if (processValue === 'PRINTING') {
  //   this.showPrintingFields = true;
  // } else {
  //   this.showPrintingFields = false;
  // }

  // Optionally, manually trigger change detection if necessary
  this.cdr.detectChanges();
  }


  get paginatedMaterialMixEntries(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.materialMixEntries.slice(startIndex, endIndex);
  }






  

  addPrintingDetail(): void {
    // Create a new material mixing object with form values
    const newMaterialMixEntry = {
      clientName: this.productionForm.value.clientName,
      jobName: this.productionForm.value.jobName,
      matArray: [{
        materialMix: this.productionForm.value.process || this.productionForm.value.material,
        refNo: this.productionForm.value.refNo,
        ticketno: this.productionForm.value.ticketno,
    poNo: this.productionForm.value.poNo,
   orderKgs: this.productionForm.value.orderKgs,

   clientName: this.productionForm.value.clientName,
      jobName: this.productionForm.value.jobName,

      shift: this.productionForm.value.shift,

      machine: this.productionForm.value.machine,
      operator: this.productionForm.value.operator,
      operatingTime: this.productionForm.value.operatingTime,
      timeFrom: this.productionForm.value.timeFrom,
      timeTo: this.productionForm.value.timeTo,
      mcSpeed: this.productionForm.value.mcSpeed,
      inkGsm: this.productionForm.value.inkGsm,
      availableTime: this.productionForm.value.availableTime,

      //checking normally 
      //for(adding extra details on table from process selection)
      // matSpecifications: this.productionForm.value.matSpecifications,






       // For Add Production
       matSpecifications: this.isAddProduction ? this.productionForm.value.matSpecifications : null,
       matRollNo: this.isAddProduction ? this.productionForm.value.matRollNo : null,
       prodWeight: this.isAddProduction ? this.productionForm.value.prodWeight : null,

       availTime: this.isAddProduction ? this.productionForm.value.availTime : null,
 
       // For Inking
       inkColor: this.isInking ? this.productionForm.value.inkColor : null,
       inkType: this.isInking ? this.productionForm.value.inkType : null,
       inkName: this.isInking ? this.productionForm.value.inkName : null,
      
        
      }]
    };
  
    // console.log(newMaterialMixEntry);
  
    // // Update the local array to include the new material mixing entry
    // this.materialMixEntries.push(newMaterialMixEntry);
    
     // Instead of updating the local array directly, we add the entry using the service
    //  this.productionService.addMaterialMixEntry(newMaterialMixEntry);

    // Update the array and save to localStorage
    this.materialMixEntries.push(newMaterialMixEntry);
    localStorage.setItem('materialMixEntries', JSON.stringify(this.materialMixEntries));
  }

  get totalProdWeight(): number {
    return this.savedProductionData.reduce((sum, item) => sum + (item.prodWeight || 0), 0);
  }
  
  get totalProdReturn(): number {
    return this.savedProductionData.reduce((sum, item) => sum + (+item.prodReturn || 0), 0);
  }
  
  get totalOutputKg(): number {
    return this.savedProductionData.reduce((sum, item) => sum + (+item.prodOutputKg || 0), 0);
  }
  
 
get totalProdWaste(): number {
  return this.savedProductionData.reduce((sum, item) => sum + (+item.prodWaste || 0), 0);
}
  
  get totalProdFlag(): number {
    // If flag is numeric:
    return this.savedProductionData.reduce((sum, item) => sum + (Number(item.prodFlag) || 0), 0);
    
    // Or if it's a string and you want a count:
    // return this.savedProductionData.filter(item => item.prodFlag === 'YourCondition').length;
  }
 

  // onSubmit(): void {
  //   if (this.productionForm.valid) {
  //  //without validation
  //   // if (this.productionForm) {
  //     // Add productionId to the form data to be sent to the backend
  //     const formData = {
  //       ...this.productionForm.value,
  //     };
  
  //     console.log('Form Data to be submitted: ', formData);
  
  //     // Send the form data along with the productionId to the service
  //     this.productionService.addProduction(formData, this.productionId).subscribe(
  //       (res: any) => {
  //         console.log('Production created successfully:', res);
  //         // This will redirect to the correct URL
  //         // this.router.navigateByUrl('/DispatchTable');  

  //         this.productionForm.reset();
  //       },
  //       (err: any) => {
  //         console.log('Error creating production:', err);
  //       }
  //     );
  //   } else {
  //     console.log('Form is invalid');
  //   }
  // }


  //(without array)(when single data entry is being saved)
  // onSubmit(): void {
  //   if (this.productionForm) {
  //     const formData = {
  //       ...this.productionForm.value,
  //       // Ensure `addProduction`, `inking`, and `breakdown` are arrays of objects.
  //       addProduction: this.isAddProduction ? [
  //         {
  //           materialCategory: this.productionForm.value.materialCategory,
  //           matSpecifications: this.productionForm.value.matSpecifications,
  //           matRollNo: this.productionForm.value.matRollNo,
  //           prodWeight: this.productionForm.value.prodWeight,
  //           prodReturn: this.productionForm.value.prodReturn,
  //           prodOutputRollNo: this.productionForm.value.prodOutputRollNo,
  //           prodOutputKg: this.productionForm.value.prodOutputKg,
  //           prodWaste: this.productionForm.value.prodWaste,
  //           prodFlag: this.productionForm.value.prodFlag,

  //           availTime: this.productionForm.value.availTime,
  //         }
  //       ] : [],
  
  //       inking: this.isInking ? [
  //         {
  //           inkType: this.productionForm.value.inkType,
  //           inkName: this.productionForm.value.inkName,
  //           inkColor: this.productionForm.value.inkColor,
  //           inkReturn: this.productionForm.value.inkReturn,
  //           issue: this.productionForm.value.issue
  //         }
  //       ] : [],
  
  //       breakdown: this.productionForm.value.breakdown ? [
  //         {
  //           downTime: this.productionForm.value.downTime,
  //           downTimeTime: this.productionForm.value.downTimeTime,
  //           downTimeRemarks: this.productionForm.value.downTimeRemarks
  //         }
  //       ] : []
  //     };
  
  //     // Send the form data
  //     this.productionService.addProduction(formData).subscribe(
  //       response => {
  //         console.log('production created successfully:', response);
  //         // Optionally reset form or perform
  //         this.productionForm.reset();

  //         // Redirect to the desired route after saving
  //         // this.router.navigate(['/prodRecord']);

  //          // After submitting, reset the form but keep specific fields intact
  //       // this.resetFormFields();
  //       },
  //       error => {
  //         console.error('Error creating production:', error);
  //       }
  //     );
  //   } else {
  //     console.log('Form is invalid:', this.productionForm.errors);
  //   }
  // }


//(with confirmation)
  onSubmit(): void {
    // Show a confirmation dialog before submitting
    const isConfirmed = window.confirm("Are you done with entering all the details for all the processes?");
  
    if (isConfirmed) {
      // Proceed with the form submission if the user clicked 'Yes'
      if (this.productionForm.valid) {
        const formData = {
          ...this.productionForm.value,
          // Aggregate the previously saved data
          addProduction: this.savedProductionData,
          inking: this.savedInkData,
          // breakdown: this.productionForm.value.breakdown ? [
          //   {
          //     downTime: this.productionForm.value.downTime,
          //     downTimeTime: this.productionForm.value.downTimeTime,
          //     downTimeRemarks: this.productionForm.value.downTimeRemarks
          //   }
          // ] : []
          // complete table entry
          breakdown: this.savedDownTimeData
        };
  
        // Log the individual sections of the form data
        console.log('addProduction:', formData.addProduction);
        console.log('inking:', formData.inking);
        console.log('breakdown:', formData.breakdown);
  
        // Log the entire form data
        console.log('Form Data to be submitted:', formData);
  
        // Send the aggregated data to the backend
        this.productionService.addProduction(formData).subscribe(
          response => {
            console.log('Production created successfully:', response);
            // Reset the form and clear the saved data after successful submission
            this.savedProductionData = [];
            this.savedInkData = [];
            this.productionForm.reset();
          },
          error => {
            console.error('Error creating production:', error);
          }
        );
      } else {
        console.log('Form is invalid:', this.productionForm.errors);
      }
    } else {
      // If the user clicked 'No', cancel the form submission
      console.log('Form submission canceled.');
    }
  }

  updateProduction(id: any){
    if (!this.productionId) {
      console.error('No production ID found.');
      return;
    }
  
    // Fetch the production details by ID
    this.productionService.getProductionById(id).subscribe(
      (res: any) => {
        // Check the response data and selectively patch values
      console.log('Fetched production data by Id:', res); // Log all data for debugging

        // Patch the values to the form
        this.productionForm.patchValue(res);
  
        // Now the form fields are populated, and the user can edit the values
        // Optionally, you can enable the form fields if needed:
        this.productionForm.enable();
      },
      (err: any) => {
        console.error('Error fetching production details:', err);
      }
    );
  }


  
  // onSubmit(): void {
  //   if (this.productionForm.valid) {
  //     const formData = {
  //       ...this.productionForm.value,
  //       // Aggregate the previously saved data
  //       addProduction: this.savedProductionData,
  //       inking: this.savedInkData,
  //       breakdown: this.productionForm.value.breakdown ? [
  //         {
  //           downTime: this.productionForm.value.downTime,
  //           downTimeTime: this.productionForm.value.downTimeTime,
  //           downTimeRemarks: this.productionForm.value.downTimeRemarks
  //         }
  //       ] : []
  //     };
  
  //     // Log the individual sections of the form data
  //     console.log('addProduction:', formData.addProduction);
  //     console.log('inking:', formData.inking);
  //     console.log('breakdown:', formData.breakdown);
      
  //     // Log the entire form data
  //     console.log('Form Data to be submitted:', formData);
  
  //     // Send the aggregated data to the backend
  //     this.productionService.addProduction(formData).subscribe(
  //       response => {
  //         console.log('Production created successfully:', response);
  //         // Reset the form and clear the saved data after successful submission
  //         this.savedProductionData = [];
  //         this.savedInkData = [];
  //         this.productionForm.reset();
  //       },
  //       error => {
  //         console.error('Error creating production:', error);
  //       }
  //     );
  //   } else {
  //     console.log('Form is invalid:', this.productionForm.errors);
  //   }
  // }
  
  



  //for(not resetting few fields)
//   resetFormFields(): void {
//     const preservedFields = [
//       'refNo', 'poNumber', 'clientName', 'jobName', 'orderKgs', 'operatorName','process', 'shift', 'machine', 'operator', 'operatingTime', 'timeFrom', 'timeTo', 'mcSpeed', 'inkGsm'
//     ];
  
//     // Preserve the values of specific fields
//     const preservedValues = {};
//     preservedFields.forEach(field => {
//       if (this.productionForm.get(field)) {
//         preservedValues[field] = this.productionForm.get(field).value;
//       }
//     });
  
//     // Reset the entire form
//     this.productionForm.reset();
  
//     // Restore the preserved values
//     Object.keys(preservedValues).forEach(field => {
//       if (this.productionForm.get(field)) {
//         this.productionForm.get(field).setValue(preservedValues[field]);
//       }
//     });
  
// }
//for(not resetting few fields)
}







































